// Checklist data for delivery tracking
const checklistData = {
  preShipment: [
    {
      id: 'business_confirmations',
      title: 'Business confirmations received',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'budget_confirmed',
      title: 'Budget done and confirmed by trader',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'invoices_created',
      title: 'Invoices created',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'contract_supplier_signed',
      title: 'Contract with supplier signed',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'contract_buyer_signed',
      title: 'Contract with buyer signed',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'vessel_nominated',
      title: 'Vessel nominated/accepted',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'vessel_sanction_check',
      title: 'Vessel sanction check',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'documentary_instructions_received',
      title: 'Documentary instructions sent / received from buyer',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'documentary_instructions_seller',
      title: 'Documentary instructions sent to seller',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'surveyor_appointed',
      title: 'Surveyor appointed ASTM/ISO',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'agent_nominated',
      title: 'Agent nominated',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'payment_secured',
      title: 'Payment secured',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'prepayment_made',
      title: 'Pre-payment made',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'lc_received',
      title: 'LC received',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'lc_issued',
      title: 'LC issued',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'cargo_insurance',
      title: 'Cargo insurance',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'pi_insurance',
      title: 'P&I insurance',
      status: 'pending',
      aiRecognition: false
    }
  ],
  afterLoading: [
    {
      id: 'bl_issued',
      title: 'BL issued',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'coo_issued',
      title: 'COO issued',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'shipper_certificates',
      title: 'Shipper\'s certificates received',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'surveyor_certificates',
      title: 'Surveyor certificates received',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'ltc_details_mercurius',
      title: 'LTC details sent to Mercurius',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'ltc_agreed_shipper',
      title: 'LTC agreed/settled with shipper',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'ltc_agreed_buyer_owner',
      title: 'LTC agreed/settled with buyer or owner',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'all_documents_issued',
      title: 'All documents issued',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'invoice_buyer_issued',
      title: 'Invoice to buyer issued',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'documents_presented_bank',
      title: 'Documents presented to bank',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'payment_received',
      title: 'Payment received',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'supplier_paid',
      title: 'Supplier paid',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'invoice_received_shipper',
      title: 'Invoice received from shipper',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'freight_paid',
      title: 'Freight paid',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'agent_disch_port',
      title: 'Agent at disch port appointed',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'pi_final_details',
      title: 'P&I final details',
      status: 'pending',
      aiRecognition: false
    }
  ],
  afterDischarge: [
    {
      id: 'finance_calculator',
      title: 'Finance calculator updated and confirmed by trader',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'ltc_details_mercurius_discharge',
      title: 'LTC details sent to Mercurius',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'ltc_agreed_buyer_owner_discharge',
      title: 'LTC agreed/settled with buyer/owner',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'ltc_agreed_shipper_owner',
      title: 'LTC agreed/settled with shipper/owner',
      status: 'pending',
      aiRecognition: false
    },
    {
      id: 'all_invoices_settled',
      title: 'All invoices settled',
      status: 'pending',
      aiRecognition: false
    }
  ]
};

export default checklistData;
